(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sms-settings', {
            parent: 'entity',
            url: '/sms-settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.SMSSettings.manageSMSSettings" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sms-settings/sms-settings.html',
                    controller: 'SMSSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('smsSettings');
                    
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
               
            }
        })
        
        .state('sms-settings.view', {
            parent: 'sms-settings',
            url: '/sms-settings/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sms-settings/sms-settings-view-dialog.html',
                    controller: 'SMSSettingsViewDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['SMSSettings', 'GlobalValues', function(SMSSettings, GlobalValues) {
                                     return SMSSettings.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('sms-settings.edit', {
            parent: 'sms-settings',
            url: '/edit/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sms-settings/sms-settings-edit-dialog.html',
                    controller: 'SMSSettingsEditDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	
                            	 entity: ['SMSSettings', 'GlobalValues', function(SMSSettings, GlobalValues) {
                                     return SMSSettings.get({id : $stateParams.id}).$promise;
                                 }]
                       
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('sms-settings-todolist', {
            parent: 'dashboard',
            url: '/smsSettings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sms-settings/sms-settings-view-dialog.html',
                    controller: 'SMSSettingsViewDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('sms-settings', null, { reload: 'sms-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        .state('sms-settings-todolist.resubmit', {
            parent: 'dashboard',
            url: '/smsSettingsEdit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sms-settings/sms-settings-edit-dialog.html',
                    controller: 'SMSSettingsEditDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                      entity: function () {                       	
                          
                        }
                    }
                }).result.then(function() {
                	$state.go('sms-settings', null, { reload: 'sms-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
          .state('sms-settings-auditLog', {
            parent: 'audit-log',
            url: '/smsSettingsAuditLog',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sms-settings/sms-settings-view-dialog.html',
                    controller: 'SMSSettingsViewDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('sms-settings', null, { reload: 'sms-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
        
         .state('sms-settings-historyReport', {
            parent: 'history-report',
            url: '/smsSettings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal',  function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sms-settings/sms-settings-view-dialog.html',
                    controller: 'SMSSettingsViewDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                    	entity: function () {                        	
                            return {                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('sms-settings', null, { reload: 'sms-settings' });
                }, function() {
                    $state.go('^');
                });
            }]
            
        })
         
         };
    })();
